import { SupportedDailyWeeklyRentalTypes } from 'enums/supportedRentalTypes';
import { dateService } from 'services/DateService';

const unitToDurationFormatter: Record<
  SupportedDailyWeeklyRentalTypes,
  (startDate: Date, endDate: Date) => number
> = {
  [SupportedDailyWeeklyRentalTypes.DAILY]: (startDate, endDate) =>
    Math.ceil(dateService.getDayDuration(startDate, endDate)),
  [SupportedDailyWeeklyRentalTypes.HALF_DAY]: (startDate, endDate) =>
    Math.ceil(dateService.getDayDuration(startDate, endDate)) + 1,
  [SupportedDailyWeeklyRentalTypes.WEEKLY]: (startDate, endDate) =>
    Math.ceil(dateService.getWeekDuration(startDate, endDate)),
};

export const getDWDuration = (
  startDate: Date,
  endDate: Date,
  demandVariant: SupportedDailyWeeklyRentalTypes
): number => {
  return unitToDurationFormatter[demandVariant](startDate, endDate);
};
